<template>
  <div>
    <router-link class="come-back" to="/admin/email_market">
      <div></div>
      Вернуться назад
    </router-link>
    <h2 class="title_categories">{{ isEdit ? 'Редактирование Рассылки' : 'Создание Рассылки' }}</h2>
    <tricolor-line class="card_containet__tricolor"/>
    <form @submit.prevent="creteMailing" ref="creteMailing">
      <div>
        <div class="content-sb">
          <p>Название<span>*</span></p>
          <input required placeholder="Введите название рассылки" v-model="editData.title" type="text" name="title"
                 class="input blue">
        </div>
        <div class="content-sb">
          <p>Текст</p>
          <ckeditor :editor-url="$root.editorUrl" v-model="editData.body"></ckeditor>
        </div>
      </div>
      <footer class="content-sb btns-create-form">
        <router-link to="/admin/email_market" class="btn-white">Отмена</router-link>
        <input type="submit" class="btn-blue" :value="isEdit ? 'Изменить' : 'Сохранить'"/>
        <input type="submit" class="btn-blue" name="sending" value='Отправить'/>
      </footer>
    </form>
  </div>
</template>

<script>
import TricolorLine from '@/components/TricolorLine'

export default {
  name: 'mailing',
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    TricolorLine
  },
  data () {
    return {
      // editData: this.$route.query.type === 'edit' ? this.$store.getters.getDetailBillDraft : {
      editData: {
        title: '',
        body: '',
        state: ''
      }
    }
  },
  methods: {
    async getMailingData () {
      const dataFromServer = await this.$store.getters.GET_MAILING_ITEM
      // console.log(this.$store.getters.GET_MAILING_ITEM)
      this.editData = {
        title: dataFromServer.title,
        body: dataFromServer.body
      }
      this.$forceUpdate()
    },
    creteMailing (params) {
      let isSend = ''
      const formData = new FormData()
      formData.append('title', this.editData.title)
      formData.append('body', this.editData.body)
      if (params.submitter.name === 'sending') {
        isSend = '1'
        formData.append('send', '1')
      } else {
        isSend = '0'
        formData.append('send', '0')
      }
      // formData.append('body', JSON.stringify(this.editData.body))
      if (this.isEdit) {
        this.$store.dispatch('updateMailing', { id: this.$route.params.id, data: formData })
        if (params.submitter.name === 'sending') {
          this.$store.dispatch('sendingMailing', { id: this.$route.params.id })
          // return 0
        }
      } else {
        this.$store.dispatch('createMailing', { data: formData, send: isSend })
      }
    }
  },
  mounted () {
    // if (this.$route.query.type === 'edit' && this.$store.getters.getDetailBillDraft === null) {
    //   this.$router.push('/admin/bill_draft')
    // }
    if (this.isEdit) {
      this.$store.dispatch('getMailingItem', this.$route.params.id)
    }
  },
  watch: {
    '$store.getters.GET_MAILING_ITEM' () {
      this.getMailingData()
    }
  }
}
</script>

<style scoped lang="scss">
  .btns-create-form {
    border-top: 1px solid #D5D6D9;
    padding-top: 2.5rem;
    margin-top: 2.5rem;
  }

  .content-sb {
    margin-bottom: 1.25rem;

    span {
      color: red;
    }
  }

  .select, .input {
    width: 33.75rem;
  }

</style>
